import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", { fill: "currentColor" }, [
      createElementVNode("path", { d: "M11.11 14.56a1.27 1.27 0 0 0 1.77 0l9.69-9.69a.5.5 0 0 0 .12-.51.51.51 0 0 0-.4-.34L22 4H1.71a.5.5 0 0 0-.4.34.48.48 0 0 0 .12.51Z" }),
      createElementVNode("path", { d: "M23.89 5.83a.18.18 0 0 0-.2 0l-6.2 6.2a.24.24 0 0 0 0 .36l5 5a.75.75 0 0 1-1.06 1.06l-5-5a.25.25 0 0 0-.36 0l-2.13 2.13a2.76 2.76 0 0 1-3.89 0l-2.12-2.09a.24.24 0 0 0-.36 0l-5 5a.75.75 0 0 1-1.06-1.06l5-5a.24.24 0 0 0 0-.36l-6.2-6.2a.18.18 0 0 0-.2 0A.18.18 0 0 0 0 6v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a.18.18 0 0 0-.11-.17" })
    ], -1)
  ]));
}
const mailSendEnvelope = { render };
export {
  mailSendEnvelope as default,
  render
};
//# sourceMappingURL=mail-send-envelope.svg.js.map
